export const getProjectStatusDetails = (fields) => {
  if (fields) {
    const statusField = fields.find((field) => field.fieldName === 'Status');
    const statusDetails =
      statusField &&
      statusField.metaData.options.find(
        (option) => option.value === Number(statusField.fieldValue),
      );

    return statusDetails;
  }

  return undefined;
};
